import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: 'input[appInput], textarea[appInput]',
})
export class InputDirective {
  constructor(public el: ElementRef<HTMLInputElement | HTMLTextAreaElement>) {}
}
